import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { periodOptions } from '@/features/osago-calculator/config/period-options';

const DEFAULT_CONTRACT_START_DATE = moment().add(1, 'day').format('DD.MM.YYYY');
const DEFAULT_CONTRACT_ESTIMATED_PERIOD = periodOptions[1]?.id ?? null;

/**
 *
 * @param storeModule
 */
export function ContractState(storeModule) {
  return {
    data() {
      return {
        contract: {
          startDate: null,
          estimatedPeriod: null,
        },
      };
    },
    mounted() {
      this.contract = {
        ...this.contract,
        startDate: this.getContractStartDate || DEFAULT_CONTRACT_START_DATE,
        estimatedPeriod: this.getContractEstimatedPeriod || DEFAULT_CONTRACT_ESTIMATED_PERIOD,
      };
    },
    computed: {
      ...mapGetters(storeModule, ['getContractStartDate', 'getContractEstimatedPeriod']),
    },
    methods: {
      ...mapActions(storeModule, ['setContractStartDate', 'setContractEstimatedPeriod']),
      contractClear() {
        this.contract = {
          ...this.contract,
          startDate: null,
          estimatedPeriod: null,
        };
      },
    },
    watch: {
      'contract.startDate'(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setContractStartDate(newValue);
        }
      },
      'contract.estimatedPeriod'(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setContractEstimatedPeriod(newValue);
        }
      },
    },
  };
}
